import { seo } from "@/constants/seo";
import { getAbsoluteUrl } from "@/utils/utils";
import { useLocation } from "react-router-dom";

interface SEOMetaProps {
  pageTitle?: string | null;
  description?: string;
  keywords?: string;
  ogImage?: string;
}

const { VITE_HEADLESS_SITE_DOMAIN } = import.meta.env;

const SEOMeta = ({ pageTitle, description, keywords, ogImage }: SEOMetaProps) => {
  const location = useLocation();
  const pageUrl = `${VITE_HEADLESS_SITE_DOMAIN}${location.pathname}`;

  const seoTitle = pageTitle
    ? `${pageTitle} | ${seo.siteName}`
    : `${seo.siteName} | ${seo.tagline}`;
  const seoDescription = description || seo.description;
  const seoKeywords = keywords || seo.keywords;
  const seoOgImage = getAbsoluteUrl(ogImage || seo.ogImage);

  return (
    <>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      {/* FB */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="zh_TW" />
      <meta property="og:site_name" content={seo.siteName} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoOgImage} />
    </>
  );
};

export default SEOMeta;
